<template>
	<div class="basis-page-cls queue-manger">
		<section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" pageNumber="pageNum" />
		</section>
		<div class="basis-cls_table">
			<div class="header">
			    <span class="title el-icon-document"> 数据列表</span>
			   <!-- <div class="btns">
			        <el-button type="primary" size="small" icon="el-icon-download" class="right">下载</el-button>
				</div> -->
			</div>
			<table-pagination
				v-loading="loading"
				ref="tableItem"
				pagination
				layout="prev,pager,next"
				:data="data"
				:column="column"
				:total="total"
				:page.sync="listQuery.pageNum"
				:limit.sync="listQuery.pageSize"
				@pagination="getList"
        />
		</div>
		<el-drawer class="customer-dialog" :modal-append-to-body="false" title="聊天详情" :visible.sync="dialogVisible"
			size="800px">
			<div class="queue-manger__dialog">
				<ul class="tabs">
					<li v-for="(item,index) in tabs" :key="index" :class="{'active':active_tab == index}">{{item.name}}</li>
				</ul>
				<div class="list">
					<history-list :sessionId="sessionId" :customerId="customerId" apiUrl="/livechat/msg/list"></history-list>
				</div>
				
			</div>
		</el-drawer>
	</div>
</template>
<script>
import {channel} from '../data.js'
import { mapGetters } from "vuex";
export default {
	computed:{
		 ...mapGetters([
			'subBrandList',
			'userInfo'
		])
	},
	data(){
		return {
			loading:false,
			data:[],
			column:[
				{ label: '序号', prop: 'index', type: 'index' },
				{ label: '品牌', prop: 'childBrandName' },
				{ label: '技能组', prop: 'skillGroup' ,render:(h,scope)=> {
					return <span>{scope.row.skillGroupName || scope.row.skillGroup}</span>
				}},
				{ label: '访客', prop: 'customerInfoDTO' ,render:(h,scope)=> {
					return <span>{scope.row.customerInfoDTO.nickname}</span>
				}},
				{ label: '渠道', prop: 'channel',render:(h,scope) => {
					return <span>{this.getChannelName(scope.row.channel)}</span>
				} },
				{ label: '开始时间', prop: 'startTime',sortable: true,
					render:(h,scope) => {return <span>{this.$dayjs(scope.row.startTime).format('YYYY-MM-DD HH:mm')}</span>}},
				{
					label: "操作",
					prop: "cation",
					align: "center",
					width: 200,
					render: (h, scope) => {
						return (
							<div class="operate-inline">
								<el-button type="text" size="small" onClick={() => this.onDetail(scope.row)}>查看详情</el-button>
							</div>
						);
					}
				}
			],
			total:0,
			listQuery:{
				brand:this.$store.state.user.brandId,
				childBrand:'',
				channel:'',
				skillName:'',
				pageNum:1,
				pageSize:10
			},
			filterHeader:[
				{ label: '品牌', model: 'childBrand', type: 'select', default: '', list: [] },
				{label:'渠道', model:'channel', type: 'select', default: '',list:channel,},
				{ label: '技能组', model: 'skillGroup', type: 'select', default: '', list: []},
			],
			dialogVisible:false,
			tabs:[
				{name:'聊天记录'},
			],
			active_tab:0,
			sessionId:'',
			customerId:'',
			timer:null
		}
	},
	watch:{
		$route:{
			handler(value){
				if(value.path != '/im/queueManage'){
					if(this.timer){
						clearInterval(this.timer);
					}
				}else {
					this.timer = setInterval(() => {
						this.getList();
					},5 * 1000)
				}
			},
			immediate:true
		}
	},
	methods:{
		filterSearch(query){
			this.listQuery = Object.assign(this.listQuery, query);
			this.getList()
		},
		onDetail(row){
			this.dialogVisible = true;
			this.sessionId = row.sessionId;
			this.customerId = row.customerInfoDTO.id
			
		},
		getList(){
			this.loading = true
			this.$api.getImQueueManageLists({
				data:{
					brand:this.listQuery.brand,
					childBrand:this.listQuery.childBrand,
					channel:this.listQuery.channel,
					skillGroup:this.listQuery.skillGroup,
				},
				pageSize:this.listQuery.pageSize,
				pageNum:this.listQuery.pageNum,
				orderBy: "create_time desc",
			}).then(res => {
				this.loading = false;
				if(res.errcode != 0) return;
				this.data = res.list;
				this.total = res.total;
			})
		},
		getSkillGroup(){
			this.$api.apiGetSkillGroupLists({brandIdentify: this.userInfo.brandIdentify}).then(response => {
				for(const item of response.data) {
					this.filterHeader[2]['list'].push({
						id: item.skillId,
						name: item.skillName
					});
				}
			});
		},
		getChannelName(key){
			let index = channel.findIndex(el => el.key == key);
			if(index != -1) return channel[index].name;
			return '--'
		},
	},
	destroyed(){
		if(this.timer){
			clearInterval(this.timer);
		}
	},
	async created(){
		await this.getSkillGroup();
		await this.getList()
		this.filterHeader[0]['list'] = await this.subBrandList;
	}
}
</script>
<style lang="scss">
.queue-manger {
	color: #3C4353;
	font-size: 14px;
	
	.customer-dialog {
		.el-dialog__header {
			border: none;
		}
	}
	&__dialog {
		padding: 20px ;
		color: #566980;
		height: 100%;
		
		.tabs{
			border-bottom: 1px solid #D8D8D8;
			display: flex;
			li {
				cursor: pointer;
				list-style: none;
				padding-bottom: 10px;
				margin-right: 42px;
				&.active {
					color: #0F81FB;
					border-bottom: 1px solid #0F81FB;
				}
			}
		}
		.list {
			height:calc(100% - 30px);
		}
	}
}
</style>